import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useCrmFacebookLeadFormPipeStatusSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data?: Partial<crmModels.IFacebookPipeStatus>) => {
      const res = await $api.post('/v1/crm/facebook/lead-form/pipe-status', data);

      return res?.data?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([crmConstants.queryKeys.CRM_FACEBOOK_APP_PIPE]);
        await qc.invalidateQueries([crmConstants.queryKeys.CRM_FACEBOOK_LEAD_FORM]);
        await qc.invalidateQueries([crmConstants.queryKeys.CRM_FACEBOOK_LEAD_FORM_ID]);
        await qc.invalidateQueries([crmConstants.queryKeys.CRM_FACEBOOK_LEAD_FORM_PIPE_STATUS]);
      },
      onError: baseErrorHandler
    }
  );
};
